export const BOOTSTRAP_WIDGETS = 'widgets/BOOTSTRAP'
export const FETCH_WIDGETS_REQUEST = 'widgets/FETCH_REQUEST'
export const FETCH_WIDGETS_SUCCESS = 'widgets/FETCH_SUCCESS'
export const FETCH_WIDGETS_FAILURE = 'widgets/FETCH_FAILURE'
export const FETCH_WIDGET_BYID_REQUEST = 'widgets/FETCH_BYID_REQUEST'
export const FETCH_WIDGET_BYID_SUCCESS = 'widgets/FETCH_BYID_SUCCESS'
export const FETCH_WIDGET_BYID_FAILURE = 'widgets/FETCH_BYID_FAILURE'
export const FETCH_WIDGET_BYID = 'widgets/FETCH_BYID'
export const FETCH_WIDGET_SETTINGS_REQUEST = 'widgets/FETCH_SETTINGS_REQUEST'
export const FETCH_WIDGET_SETTINGS_SUCCESS = 'widgets/FETCH_SETTINGS_SUCCESS'
export const FETCH_WIDGET_SETTINGS_FAILURE = 'widgets/FETCH_SETTINGS_FAILURE'
export const FETCH_WIDGET_SNIPPET_REQUEST = 'widgets/FETCH_SNIPPET_REQUEST'
export const FETCH_WIDGET_SNIPPET_SUCCESS = 'widgets/FETCH_SNIPPET_SUCCESS'
export const FETCH_WIDGET_SNIPPET_FAILURE = 'widgets/FETCH_SNIPPET_FAILURE'
export const UPDATE_WIDGET_SETTINGS_REQUEST = 'widgets/UPDATE_SETTINGS_REQUEST'
export const UPDATE_WIDGET_SETTINGS_SUCCESS = 'widgets/UPDATE_SETTINGS_SUCCESS'
export const UPDATE_WIDGET_SETTINGS_FAILURE = 'widgets/UPDATE_SETTINGS_FAILURE'
export const PUBLISH_WIDGET_SETTINGS_REQUEST =
  'widgets/PUBLISH_SETTINGS_REQUEST'
export const PUBLISH_WIDGET_SETTINGS_SUCCESS =
  'widgets/PUBLISH_SETTINGS_SUCCESS'
export const PUBLISH_WIDGET_SETTINGS_FAILURE =
  'widgets/PUBLISH_SETTINGS_FAILURE'
export const REVERT_WIDGET_SETTINGS_REQUEST = 'widgets/REVERT_SETTINGS_REQUEST'
export const REVERT_WIDGET_SETTINGS_SUCCESS = 'widgets/REVERT_SETTINGS_SUCCESS'
export const REVERT_WIDGET_SETTINGS_FAILURE = 'widgets/REVERT_SETTINGS_FAILURE'
export const CREATE_WIDGET_REQUEST = 'widgets/CREATE_REQUEST'
export const CREATE_WIDGET_SUCCESS = 'widgets/CREATE_SUCCESS'
export const CREATE_WIDGET_FAILURE = 'widgets/CREATE_FAILURE'
export const UPDATE_WIDGET_REQUEST = 'widgets/UPDATE_REQUEST'
export const UPDATE_WIDGET_SUCCESS = 'widgets/UPDATE_SUCCESS'
export const UPDATE_WIDGET_FAILURE = 'widgets/UPDATE_FAILURE'
export const DELETE_WIDGET_REQUEST = 'widgets/DELETE_REQUEST'
export const DELETE_WIDGET_SUCCESS = 'widgets/DELETE_SUCCESS'
export const DELETE_WIDGET_FAILURE = 'widgets/DELETE_FAILURE'
export const UPDATE_WIDGET_PREVIEW_MESSAGE = 'widgets/UPDATE_PREVIEW_MESSAGE'
export const CREATE_DRAFT_WIDGET_REQUEST = 'widgets/CREATE_DRAFT_WIDGET_REQUEST'
export const CREATE_DRAFT_WIDGET_SUCCESS = 'widgets/CREATE_DRAFT_WIDGET_SUCCESS'
export const UPDATE_DRAFT_WIDGET = 'widgets/UPDATE_DRAFT_WIDGET'
export const DESTROY_DRAFT_WIDGET = 'widgets/DESTROY_DRAFT_WIDGET'
